const config = {
    apiUrl: process.env.GATSBY_API_URL || "http://internal-cur:7080",
    portalUrl: process.env.GATSBY_PORTAL_URL || "/portal",
    authUrl: process.env.GATSBY_AUTH_URL || "",
    authEndpoint: process.env.GATSBY_AUTH_ENDPOINT || "/check-login.json",
    externalUrl: process.env.GATSBY_EXTERNAL_URL || "",
}

export default config;